import {styledByTheme} from "../../../../../../themes/architecture/styled-by-theme";
import {ButtonsActiveIndicatorDefaultBox} from "./buttons-active-indicator.default.box";
import {ButtonsActiveIndicatorSIBox} from "./buttons-active-indicator.si.box";

export const ButtonsActiveIndicatorBox = styledByTheme(ButtonsActiveIndicatorDefaultBox)
    .forSI(ButtonsActiveIndicatorSIBox)
    .forSICis(ButtonsActiveIndicatorSIBox)
    .forMrGreen(ButtonsActiveIndicatorSIBox)
    .apply();